import { Button } from "../../components/Button";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import MuiInput from "../../components/MuiInput";
import { changePasswordValidate, userState } from "./userSlice";
import { Oval } from "react-loader-spinner";
import { showNotification } from "../../components/Notification";
import { sendOTP, validateChangePassword } from "../../api/userApi";
import { Card } from "@material-tailwind/react";
import { decrypt } from "../../uitls/Utils";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [submitReferenceState, setSubmitReferenceState] = useState(false);
  const [email, setEmail] = useState(null);
  const [encryptedEmail] = useState(searchParams.get("email"));
  const stateOfUser = useSelector(userState);
  const stateOfChangePass = useSelector(changePasswordValidate);

  const trimObjectValues = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(trimObjectValues);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key] = trimObjectValues(obj[key]);
        return acc;
      }, {});
    } else if (typeof obj === "string") {
      return obj.trim();
    }
    return obj;
  };

  useEffect(() => {
    if (
      !stateOfUser.error &&
      submitReferenceState &&
      stateOfUser.status === "succeeded"
    ) {
      showNotification("success", "Verification Code sent successfully");
      navigate("/update-user-password", {
        state: { email },
      });
    }
    setSubmitReferenceState(false);
  }, [submitReferenceState]);

  useEffect(() => {
    if (encryptedEmail) {
      const decodedValue = decodeURIComponent(encryptedEmail);
      const decrypteData = decrypt(decodedValue);
      if (decrypteData) {
        const { corporateEmail } = JSON.parse(decrypteData);
        dispatch(
          validateChangePassword({
            corporateEmail,
            tempPass: searchParams.get("tempPass"),
          })
        )
          .then((res) => {
            if (res.payload === "success") {
              setEmail(corporateEmail);
            } else {
              navigate("/signIn");
            }
          })
          .catch(() => navigate("/signIn"));
      } else {
        navigate("/signIn");
      }
    }
  }, [encryptedEmail, navigate]);

  const handleSubmit = () => {
    if (email) {
      dispatch(sendOTP(trimObjectValues({ email })))
        .unwrap()
        .then(() => {
          setSubmitReferenceState(true);
        })
        .catch((error) => {
          console.error("Error:", error);
          showNotification(
            "error",
            error?.message || "Something went wrong..."
          );
        });
    }
  };

  return (
    <div className="min-h-screen bg-white xsm:bg-[#055173]  ">
      <div className="absolute inset-0 flex justify-center items-center sm:p-5 ">
        <div className=" w-full p-2 xsm:p-0  grid grid-cols-1 md:grid-cols-2   sm:w-[90%] lg:w-[90%] h-[90%] ">
          <div className="hidden md:flex items-center justify-center bg-white rounded-l-lg">
            <div className=" flex h-[80%] justify-center self-center  items-center ">
              <img
                src="/images/forgotPassword.png"
                alt="Password reset illustration"
                style={{
                  width: "70%",
                  height: "70%",
                  borderRadius: "10%",
                  objectFit: "fill",
                }}
              />
            </div>
          </div>
          <Card className="bg-white xsm:p-5 flex flex-col  items-center rounded-l-none  ">
            <div className="mb-8 pt-8">
              <div className="w-full flex flex-col  mb-1 justify-center">
                <h2 className="flex font-semibold text-xl sm:text-xl flex-1  mb-4">
                  To continue using the application, please update your
                  password.
                </h2>
                <p className="text-gray-600 text-sm mb-8">
                  We will send a verification code to your registered email. Use
                  it to securely update your password and regain access.
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-start w-full ml-2 "></div>
            <div className="w-full">
              <div className="mb-5 w-full">
                <MuiInput
                  label="Organizational Email"
                  name="corporateEmail"
                  type="email"
                  value={email}
                  readOnly={true}
                />
              </div>

              <div className="flex flex-col items-center justify-center w-full mb-2 h-8">
                {(stateOfUser?.loading || stateOfChangePass?.loading) && (
                  <Oval
                    height={35}
                    width={35}
                    color={"#1f7fbb"}
                    ariaLabel="loading"
                    strokeWidth={3}
                  />
                )}
              </div>
              <div className="flex flex-col justify-center items-center w-full">
                <Button
                  className="w-full"
                  type="button"
                  value="Send"
                  disabled={stateOfUser?.loading || stateOfChangePass?.loading}
                  handleClick={handleSubmit}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
